import { Card as MuiCard, CardProps as MuiCardProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useDeckContext } from './stackable-card-deck.component';

export type StackableCardProps = MuiCardProps & {
  /**
   * Any optional classes
   */
  className?: string;
};

export const StackableCard: React.FC<StackableCardProps> = ({
  children,
  className,
  elevation = 1,
  ...props
}) => {
  const { classes, cx } = useStyles();
  const ctx = useDeckContext();

  return (
    <MuiCard
      className={cx(
        classes.root,
        ctx?.direction === 'horizontal' ? classes.horizontal : classes.vertical,
        className
      )}
      square
      elevation={elevation}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

const useStyles = makeStyles({ name: 'StackableCard' })(theme => ({
  root: {
    boxShadow: 'none',
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up('sm')]: {
      boxShadow: theme.shadows[1],
      padding: theme.spacing(3)
    },
  },
  horizontal: {
    flex: 1,
    '&:first-child': {
      borderRadius: 0,
      borderLeft: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        borderRadius: '4px 0 0 4px',
        borderLeft: 'none',
      }
    },
    '&:last-child': {
      borderRadius: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        borderRight: 'none',
        borderRadius: '0 4px 4px 0'
      }
    },
    '&:not(:last-child)': {
      border: 0,
      borderRight: `1px solid ${theme.palette.divider}`
    },
  },
  vertical: {
    '&:first-child': {
      borderRadius: 0,
      borderTop: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        borderRadius: '4px 4px 0 0',
        borderTop: 'none',
      }
    },
    '&:last-child': {
      borderRadius: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        borderBottom: 'none',
        borderRadius: '0 0 4px 4px'
      }
    },
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '&:first-child:last-child': {
      borderRadius: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderTop: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        borderRadius: '4px',
        borderTop: 'none',
      },
    }
  },
}));
